import React, { useContext } from 'react';
import { LanguageContext } from '../../../context/LanguageContext/LanguageContext';
import MainBanner from '../../Nosotros/MainBanner/MainBanner';
import KnowService from '../KnowService/KnowService';
import ServiceList from '../ServiceList/ServiceList';
import ServiceBanner from '../ServicesBanner/ServicesBanner';
import { mainBannerComerciales, mainBannerComercialesEn } from '../../../json/services/comerciales/mainBannerComerciales';
import { knowServiceComerciales, knowServiceComercialesEn } from '../../../json/services/comerciales/knowServiceComerciales';
import { serviceListComerciales, serviceListComercialesEn } from '../../../json/services/comerciales/serviceListComerciales';
import { ServicesBannerComerciales, ServicesBannerComercialesEn } from '../../../json/services/comerciales/servicesBannerComerciales';

const Comerciales = () => {
  const { language } = useContext(LanguageContext);
  const data = language === 'ES'
    ? mainBannerComerciales[0]
    : mainBannerComercialesEn[0];

  const content = language === 'ES' ? knowServiceComerciales[0] : knowServiceComercialesEn[0];

  const services = language === "ES" ? serviceListComerciales : serviceListComercialesEn;

  const dataServiceBanner = language === 'ES'
    ? ServicesBannerComerciales[0]
    : ServicesBannerComercialesEn[0];
  return (
    <>
      <MainBanner {...data} />
      <KnowService content={content} />
      <ServiceList services={services} />
      <ServiceBanner dataServiceBanner={dataServiceBanner} />
    </>
  )
}

export default Comerciales